import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} viewBox="0 0 29 29" {...props}>
      <defs>
        <style>{`.prefix__cls-2{fill:${props.fillPrimary}}`}</style>
      </defs>
      <g id="prefix__Group_2342" transform="translate(-222 -563)">
        <rect
          id="prefix__Rectangle_836"
          width={29}
          height={29}
          fill={props.fillSecondary}
          rx={10}
          transform="translate(222 563)"
        />
        <g id="prefix__Group_1855" transform="translate(228 568.688)">
          <g id="prefix__Group_1852" transform="translate(3.713 .958)">
            <path
              id="prefix__Rectangle_741"
              d="M0 0h1.302v3.07H0z"
              className="prefix__cls-2"
              transform="translate(4.136 10.649)"
            />
            <path
              id="prefix__Path_5398"
              d="M246.963 239.685v3.84a8.569 8.569 0 003.487 6.9l1.3.958 1.3-.958a8.568 8.568 0 003.487-6.9v-3.84z"
              className="prefix__cls-2"
              transform="translate(-246.963 -239.685)"
            />
          </g>
          <path
            id="prefix__Path_5399"
            d="M256.416 239.843h-10.277a.271.271 0 01-.271-.271v-.772a.271.271 0 01.271-.271h10.277a.271.271 0 01.271.271v.774a.271.271 0 01-.271.269z"
            className="prefix__cls-2"
            transform="translate(-242.777 -238.228)"
          />
          <path
            id="prefix__Path_5400"
            d="M263.262 238.528h-1.529v1.315h1.529a.271.271 0 00.271-.271v-.772a.271.271 0 00-.271-.272z"
            className="prefix__cls-2"
            transform="translate(-249.623 -238.228)"
          />
          <path
            id="prefix__Path_5401"
            fill="#040628"
            d="M253.652 244.788l.68 1.378a.061.061 0 00.046.033l1.521.221a.06.06 0 01.033.1l-1.1 1.073a.062.062 0 00-.017.053l.26 1.514a.06.06 0 01-.087.063l-1.36-.715a.061.061 0 00-.056 0l-1.36.715a.06.06 0 01-.087-.063l.26-1.514a.06.06 0 00-.017-.053l-1.1-1.073a.06.06 0 01.033-.1l1.521-.221a.058.058 0 00.045-.033l.681-1.378a.06.06 0 01.104 0z"
            opacity={0.2}
            transform="translate(-245.098 -240.915)"
          />
          <g id="prefix__Group_1853" transform="translate(5.961 11.894)">
            <path
              id="prefix__Path_5402"
              d="M255.181 260.142H253.7a.5.5 0 01-.5-.5v-.216a.5.5 0 01.5-.5h1.478a.5.5 0 01.5.5v.216a.5.5 0 01-.497.5z"
              className="prefix__cls-2"
              transform="translate(-251.902 -258.923)"
            />
            <path
              id="prefix__Path_5403"
              d="M256 264.029h-5.079v-1.081a.674.674 0 01.674-.674h3.731a.674.674 0 01.674.674z"
              className="prefix__cls-2"
              transform="translate(-250.916 -260.369)"
            />
          </g>
          <g id="prefix__Group_1854" transform="translate(4.167 13.799)">
            <path
              id="prefix__Path_5404"
              d="M257.815 262.274H256.7v1.755h1.794v-1.081a.674.674 0 00-.679-.674z"
              className="prefix__cls-2"
              transform="translate(-251.616 -262.274)"
            />
            <path
              id="prefix__Path_5405"
              d="M256.052 266.8h-7.915a.376.376 0 01-.369-.448l.284-1.451a.375.375 0 01.369-.3h7.348a.376.376 0 01.369.3l.284 1.451a.376.376 0 01-.37.448z"
              className="prefix__cls-2"
              transform="translate(-247.76 -263.277)"
            />
          </g>
          <path
            id="prefix__Path_5406"
            d="M261.352 266.353l-.284-1.451a.376.376 0 00-.369-.3h-1.51l.431 2.2h1.363a.376.376 0 00.369-.449z"
            className="prefix__cls-2"
            transform="translate(-248.525 -249.477)"
          />
          <path
            id="prefix__Path_5407"
            d="M257.166 239.641a.9.9 0 00-.638-.264 2.05 2.05 0 00-1.682.886l-.233.338a.705.705 0 01-.58.3h-.012v-.991h.052a.572.572 0 00.571-.571v-.774a.572.572 0 00-.571-.571h-10.28a.572.572 0 00-.571.571v.774a.572.572 0 00.571.571h.052v.991h-.012a.706.706 0 01-.58-.3l-.234-.338a2.05 2.05 0 00-1.682-.886.9.9 0 00-.906.9v1.254c0 3 1.541 3.628 2.779 4.131a2.645 2.645 0 011.583 1.12.364.364 0 01-.053.444.586.586 0 01-.6.146c-.214-.092-.248-.359-.239-.568a.3.3 0 10-.6-.027 1.134 1.134 0 00.6 1.148 1.043 1.043 0 00.409.081 1.208 1.208 0 00.864-.365.94.94 0 00.067-.078 8.845 8.845 0 002.213 2.373l.056.041a.794.794 0 00-.118.416v.217a.8.8 0 00.59.772v.115h-.915a.975.975 0 00-.974.974v.347h-.834a.677.677 0 00-.663.547l-.284 1.451a.676.676 0 00.663.806h7.915a.676.676 0 00.663-.806l-.284-1.451a.678.678 0 00-.663-.547h-.834v-.347a.976.976 0 00-.974-.974h-.915v-.115a.8.8 0 00.589-.772v-.21a.793.793 0 00-.118-.416l.056-.041a8.852 8.852 0 002.213-2.373c.021.027.043.053.066.078a1.21 1.21 0 00.864.365 1.042 1.042 0 00.409-.081 1.133 1.133 0 00.6-1.148.3.3 0 10-.6.027c.01.209-.024.477-.239.568a.586.586 0 01-.6-.146.362.362 0 01-.053-.443 2.641 2.641 0 011.583-1.121c1.238-.5 2.779-1.128 2.779-4.131v-1.255a.9.9 0 00-.266-.642zm-13.73 5.469a4.207 4.207 0 01-1.648-.986 3.751 3.751 0 01-.757-2.588v-1.255a.3.3 0 01.3-.3 1.451 1.451 0 011.19.627l.233.338a1.3 1.3 0 001.074.564h.012v1.29a8.838 8.838 0 00.419 2.684 8.6 8.6 0 00-.823-.374zm7.361 6.99a.375.375 0 01.375.374v.347H248.5a.3.3 0 000 .6h4.1a.076.076 0 01.074.061l.284 1.451a.075.075 0 01-.016.063.074.074 0 01-.059.028h-7.915a.074.074 0 01-.058-.028.075.075 0 01-.016-.063l.283-1.451a.076.076 0 01.075-.061h1.85a.3.3 0 000-.6h-.417v-.347a.375.375 0 01.375-.374zm-2.6-1.286a.2.2 0 01-.2-.2v-.214a.2.2 0 01.2-.2h1.478a.2.2 0 01.2.2v.217a.2.2 0 01-.2.2zm1.09.6v.085h-.7v-.085zm4.136-8.617a8.3 8.3 0 01-3.365 6.658l-.213.158a.8.8 0 00-.17-.019h-1.478a.794.794 0 00-.17.019l-.213-.158a8.3 8.3 0 01-3.365-6.658v-2.882h5.627a.3.3 0 000-.6h-6.25v-.715h10.219v.716h-2.574a.3.3 0 100 .6h1.951v2.884zm3.413-1.262a3.751 3.751 0 01-.757 2.588 4.207 4.207 0 01-1.648.986 8.591 8.591 0 00-.828.371 8.837 8.837 0 00.419-2.683v-1.292h.012a1.306 1.306 0 001.074-.564l.233-.338a1.45 1.45 0 011.19-.627.3.3 0 01.3.3v1.255z"
            className="prefix__cls-2"
            transform="translate(-240.431 -238)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
